const ROOT_PICKER_INJECTION_KEY = Symbol();
const ROOT_PICKER_IS_DEFAULT_FORMAT_INJECTION_KEY = "ElIsDefaultFormat";

export { ROOT_PICKER_INJECTION_KEY, ROOT_PICKER_IS_DEFAULT_FORMAT_INJECTION_KEY };
//# sourceMappingURL=constants.mjs.map
